import axios from "axios";
// require('dotenv').config();

class PhonesApi {
    constructor() {
        this.phonesApi = axios.create({
            baseURL: "https://ohilari-phone-app.herokuapp.com/api/phones"
            // baseURL: "http://localhost:5000/api/phones"
        });
    }

    getProducts() {
        return this.phonesApi.get(`/`).then(({ data }) => data);
    }

    getProduct(id) {
        return this.phonesApi.get(`/${id}`).then(({ data }) => data);
    }

    editProduct(id, body) {
        return this.phonesApi.put(`/${id}`, body);
    }
    
    deleteProduct(id) {
        return this.phonesApi.delete(`/${id}`);
    }
    
    //   createProduct(id, body) {
    //     return this.phonesApi.put(`/${id}`, body);
    //   }
}

const phonesApi = new PhonesApi();

export default phonesApi;